<script>

import { Form } from 'vee-validate';
import TextInput from '../components/TextInput.vue'
import * as Yup from 'yup';
import useAuthUser from "../components/UseAuthUser";
import { useRouter } from "vue-router";


const { signUp } = useAuthUser()
export default {
    name: "Signup",
    components: {
        Form, TextInput


    },
    setup() {
        const router = useRouter();
        const schema = Yup.object().shape({
            fseNumber: Yup.number().min(10000).required().label('FSE Number').typeError('You Must Specify a Number'),
            firstName: Yup.string().required().label('First Name'),
            lastName: Yup.string().required().label('Last Name'),
            email: Yup.string().email().required().label('Email Address'),
            password: Yup.string().required('Password is required').min(6, 'Minimum of 6 Characters'),
            passwordConfirmation: Yup.string().min(6, 'Minimum of 6 Characters')
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
        });

        async function onSubmit(form) {
            console.log('Submitting ', form);
            const meta = { fse_number: fseNumber.value, username: email.value, full_name: firstName.value + " " + lastName.value }
            form.meta = meta
            try {
                await signUp(form)
                console.log(router);
                router.push({
                    name: "EmailConfirmation",
                    query: { email: email.value },
                });
            } catch (error) {
                alert(error.message);
            }
        }
        function onInvalidSubmit(form) {
            const submitBtn = document.querySelector('.submit-btn');
            submitBtn.classList.add('invalid');
            setTimeout(() => {
                submitBtn.classList.remove('invalid');
            }, 1000);
        }

        return {
            schema,
            onSubmit,
            onInvalidSubmit,

        }

    }

}



</script>
<template>
    <Form class="form" @submit="onSubmit" @invalid-submit="onInvalidSubmit" :validation-schema="schema">

        <TextInput name="fseNumber" type="text" label="Engineer Number" placeholder="Your Engineer Number"
            success-message="" />
        <TextInput name="firstName" type="text" label="First Name" placeholder="Your First Name" success-message="" />
        <TextInput name="lastName" type="text" label="Last Name" placeholder="Your Last Name" success-message="" />
        <TextInput name="email" type="text" label="Email Address" placeholder="Your Email Address" success-message="" />
        <TextInput name="password" type="password" label="Password" placeholder="Password" success-message="" />
        <TextInput name="passwordConfirmation" type="password" label="Password Confirmation"
            placeholder="Confirm Your Password" success-message="" />
        <button class="submit-btn" type="submit">Submit</button>
    </Form>
</template>
<style>
* {
    box-sizing: border-box;
}

:root {
    --primary-color: #feba00;
    --error-color: #f23648;
    --error-bg-color: #fddfe2;
    --success-color: #21a67a;
    --success-bg-color: #e0eee4;
}

:root.dark-theme {
    --primary-color: #feba00;
    --background-color-primary: #1e1e1e;
    --background-color-secondary: #2d2d30;
    --accent-color: #3f3f3f;
    --text-primary-color: #ddd;
}


#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;


    width: 100%;
    height: 100%;
}

.form {
    margin-top: 20px;
}

::-webkit-input-placeholder {
    color: #ccc;
}

.error {
    font-size: 0.75rem;
    color: red;
}

.error+.error {
    margin-left: 0.5rem;
}

.form-group+.form-group {
    margin-top: 2rem;
}

input {
    appearance: none;
    background: #f2f2f2;
    border: 2px solid transparent;
    border-radius: 0.2rem;
    font-size: 1rem;
    padding: 0.5rem;
    width: 20rem;
}

input:focus {
    outline: none;
    border-color: #f8c331;
}



form {
    width: 100%;
    margin: 0px auto;
    padding-bottom: 60px;
}

.submit-btn {
    background: var(--primary-color);
    outline: none;
    border: none;
    color: rgb(255, 255, 255);
    font-size: 18px;
    padding: 10px 15px;
    display: block;
    width: 100%;
    border-radius: 7px;
    margin-top: 40px;
    transition: transform 0.3s ease-in-out;
    cursor: pointer;
}

.submit-btn.invalid {
    animation: shake 0.5s;
    /* When the animation is finished, start again */
    animation-iteration-count: infinite;
}

@keyframes shake {
    0% {
        transform: translate(1px, 1px);
    }

    10% {
        transform: translate(-1px, -2px);
    }

    20% {
        transform: translate(-3px, 0px);
    }

    30% {
        transform: translate(3px, 2px);
    }

    40% {
        transform: translate(1px, -1px);
    }

    50% {
        transform: translate(-1px, 2px);
    }

    60% {
        transform: translate(-3px, 1px);
    }

    70% {
        transform: translate(3px, 1px);
    }

    80% {
        transform: translate(-1px, -1px);
    }

    90% {
        transform: translate(1px, 2px);
    }

    100% {
        transform: translate(1px, -2px);
    }
}

.submit-btn:hover {
    transform: scale(1.1);
}
</style>